<template>
  <div class="CustomOrderDetail">
    <div v-if="info.orderContent">
      <div class="order-item-title">表单详情</div>
      <div v-for="(item, index) in info.orderContent" :key="index" class="order-content">
        <p class="" v-if="item.type !== 7">
          <span class="lable text-right">{{item.title}}: </span>
          <span class="m_l20 in_b">{{item.value ? item.value : '-'}}</span>
        </p>
        <div class="pic-list" v-if="item.type === 7">
          <span class="lable text-right"> {{item.title}}: </span>
          <div class="pic-items">
            <img v-for="(v, k) in getImgUrl(item.value)" :key="k" :src="v" alt="" class="img_b">
          </div>
        </div>
      </div>
    </div>
    <div v-if="info.processList">
      <div class="order-item-title">订单流程</div>
      <div class="ajie_table m_t10">
        <el-table :data="info.processList" border align="center">
          <el-table-column label="步骤" width="50px" align="center" type="index"></el-table-column>
          <el-table-column label="说明" width="250px" align="center" prop="description"></el-table-column>
          <el-table-column label="处理人" width="270px" align="center" prop="userName"></el-table-column>
          <el-table-column label="处理结果" width="100px" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.operateStatus">{{scope.row.operateStatus==1 ? '通过' : '不通过'}}</p>
              <p v-else>待处理</p>
            </template>
          </el-table-column>
          <el-table-column label="处理时间" width="178px" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.operateStatus">{{scope.row.operateTime | DateFilter('yyyy-MM-dd hh:mm:ss')}}</p>
              <p v-else>——</p>
            </template>
          </el-table-column>
          <el-table-column label="意见" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.operateStatus">{{scope.row.remark}}</p>
              <p v-else>——</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return{};
      },
    },
  },
  methods: {
    getImgUrl(value) {
      return typeof value === 'string' ? value.split(',') : [];
    },
  },
}
</script>
<style lang="scss" scoped>
.order-content{
  font-size: 16px;
  >div {
    transform: translateX(-30deg);
  }
  .text-right {
    text-align: left;
    padding-right: 10px;
  }
  .pic-list {
    display: -webkit-box;
    .pic-items {
      max-width: 85%;
      img {
        padding: 5px;
        border: 1px solid #ccc;
        margin: 5px;
      }
    }
  }
}
.lable{
  display: inline-block;
  vertical-align: middle;
  width: 192px;
  text-align: center;
}
.img_b{
  display: inline-block;
  vertical-align: top;
  width: 114px;
  height: 117px;
  margin-left: 20px;
}
.m_l20{
  margin-left: 20px;
}
.in_b{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/CustomOrderDetail.vue